import { render, staticRenderFns } from "./people_switch.vue?vue&type=template&id=6acb455d&scoped=true"
import script from "./people_switch.vue?vue&type=script&lang=js"
export * from "./people_switch.vue?vue&type=script&lang=js"
import style0 from "./people_switch.vue?vue&type=style&index=0&id=6acb455d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acb455d",
  null
  
)

export default component.exports